import axios from "axios";

export function request(params) {
  // 创建 axios 实例
  const instance = axios.create({

    timeout: 10000,
  
  });

  // 请求拦截器
  instance.interceptors.request.use(
    config => {
   
      return config;
    },
    error => {
      console.log(error);
      return Promise.reject(error);
    }
  );

  // 响应拦截器
  instance.interceptors.response.use(
    response => {
      // 在响应返回后进行拦截，可以在此处对响应进行处理
      // 例如统一处理错误、格式化数据等
      return response.data;
    },
    error => {
      // console.log(error);
      return Promise.reject(error);
    }
  );

  return instance(params);
}